import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Variable, VariableApiResponse } from '../models/variable.model';
import { NavigationContextService } from '../../core/services/navigation-context.service';

@Injectable({
  providedIn: 'root'
})
export class VariableRegistryService {
  private http = inject(HttpClient);
  private navContext = inject(NavigationContextService);
  private apiUrl = `${environment.backofficeApiUrl}/api/v1/variables`;

  /**
   * Get all variables (paginated) - con filtri automatici dal contesto
   */
  getVariables(): Observable<VariableApiResponse> {
    const context = this.navContext.getCurrentContext();
    let params = new HttpParams()
      .set('domainType', context.domainType);
    
    console.log('[VariableService] Loading variables with context:', context);
    return this.http.get<VariableApiResponse>(this.apiUrl, { params });
  }

  /**
   * Get a single variable by ID
   */
  getVariable(id: string | number): Observable<VariableApiResponse> {
    return this.http.get<VariableApiResponse>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create a new variable
   * Nota: Secondo le specifiche, Variables sono SOLO LETTURA nel frontend
   */
  createVariable(variable: Variable): Observable<VariableApiResponse> {
    return this.http.post<VariableApiResponse>(this.apiUrl, variable);
  }

  /**
   * Update an existing variable (PUT - full update)
   * Nota: Secondo le specifiche, Variables sono SOLO LETTURA nel frontend
   */
  updateVariablePut(id: string | number, variable: Variable): Observable<VariableApiResponse> {
    return this.http.put<VariableApiResponse>(`${this.apiUrl}/${id}`, variable);
  }

  /**
   * Delete a variable
   * Nota: Secondo le specifiche, Variables sono SOLO LETTURA nel frontend
   */
  deleteVariable(id: string | number): Observable<VariableApiResponse> {
    return this.http.delete<VariableApiResponse>(`${this.apiUrl}/${id}`);
  }
}
